/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Aci_Number_ShortInputs */

const en_cargos_aci_number_short = /** @type {(inputs: Cargos_Aci_Number_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ACI #`)
};

const es_cargos_aci_number_short = /** @type {(inputs: Cargos_Aci_Number_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ACI #`)
};

/**
* | output |
* | --- |
* | "ACI #" |
*
* @param {Cargos_Aci_Number_ShortInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_aci_number_short = /** @type {((inputs?: Cargos_Aci_Number_ShortInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Aci_Number_ShortInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_aci_number_short(inputs)
	return es_cargos_aci_number_short(inputs)
});